import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext, API } from '@/App';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export default function ClientHistory() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || user.user_type !== 'client') {
      navigate('/client/login');
      return;
    }
    fetchServices();
  }, [user, navigate]);

  const fetchServices = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API}/client/services`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setServices(res.data.services);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="flex items-center justify-center h-screen">Carregando...</div>;

  return (
    <div className="min-h-screen bg-slate-50 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold" data-testid="history-title">Histórico de Serviços</h1>
          <Button onClick={() => navigate('/client/dashboard')} data-testid="back-btn">Voltar</Button>
        </div>

        {services.length === 0 ? (
          <Card className="p-8 text-center">
            <p className="text-muted-foreground">Nenhum serviço realizado ainda</p>
          </Card>
        ) : (
          <div className="space-y-4">
            {services.map((service) => (
              <Card key={service.id} className="p-4">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-semibold">{service.service_type === 'complete' ? 'Lavagem Completa' : 'Ducha Simples'}</p>
                    <p className="text-sm text-muted-foreground">
                      {new Date(service.date).toLocaleDateString('pt-BR')}
                    </p>
                  </div>
                  <span className={`px-3 py-1 rounded-full text-sm ${
                    service.status === 'completed' ? 'bg-green-100 text-green-800' :
                    service.status === 'checked_in' ? 'bg-blue-100 text-blue-800' :
                    'bg-yellow-100 text-yellow-800'
                  }`}>
                    {service.status}
                  </span>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
